// extracted by mini-css-extract-plugin
export var container = "_e9-0";
export var infoIcon = "_e9-2";
export var internalLabel = "_e9-3";
export var titleRowCol = "_e9-1";